import React from 'react';
import { Button } from 'react-bootstrap';

import { Props } from './flowTypes';
import './style.scss';

const BorderButton = (props: Props) => (
  <Button
    {...props}
    className={`border-button ${props.className}`}
  >
    {props.children}
  </Button>
);

export default BorderButton;
